import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useRealtime } from '../components/hooks/useRealtime';
import { MainPageLayout } from './MainPageLayout';

interface IMainPageProps {}

let MainPage: React.FunctionComponent<IMainPageProps> = () => {
  useRealtime('global');

  return (
    <BrowserRouter>
      <MainPageLayout />
    </BrowserRouter>
  );
};

MainPage = React.memo<IMainPageProps>(MainPage);
export { MainPage };
